import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export class NewsSlider {
    private readonly container: HTMLElement;
    private swiperPagination: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.swiperPagination = this.container.querySelector(".swiper-pagination");

        this.initSlider();
    }

    private initSlider = () => {
        new Swiper(this.container, {
            modules: [Navigation, Pagination],
            spaceBetween: 50,
            pagination: {
                el: ".swiper-pagination",
                type: "custom",
                renderCustom: (_swiper, current, total) => {
                    return this.swiperPagination.dataset.text
                        .replace("%page", `${current}`)
                        .replace("%total", `${total}`);
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    };
}
